import { Button } from 'antd';
import { TrialPlan } from 'hydra-data-types';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { ActionType } from '../../store/ActionTypes';
import { PricingSelector } from '../../store/pricing/PricingActions';
import { useAppDispatch, useAppStore } from '../../store/Store';
import { BodyXS } from '../styles/Typography';

export const TrialOptionButtons: FunctionComponent = () => {
  const trialPlan = useAppStore((state) => state.purchase.trialPlan);
  const dispatch = useAppDispatch();

  function setTrialPlan(trialPlan: TrialPlan) {
    dispatch({ type: ActionType.SET_SELECTED_TRIAL_PLAN, trialPlan });
  }

  return (
    <ChoiceContainer>
      <Choice
        selected={trialPlan === TrialPlan.OneDollarTrial}
        data-test="oneDollar"
        onClick={() => setTrialPlan(TrialPlan.OneDollarTrial)}
      >
        <TrialPrice plan={TrialPlan.OneDollarTrial} />
      </Choice>
      <Choice
        selected={trialPlan === TrialPlan.SixteenDollarTrial}
        data-test="sixteenDollars"
        onClick={() => setTrialPlan(TrialPlan.SixteenDollarTrial)}
      >
        <TrialPrice plan={TrialPlan.SixteenDollarTrial} />
      </Choice>
    </ChoiceContainer>
  );
};

type TrialPriceParagraphProps = {
  plan: TrialPlan;
};

const TrialPrice: FunctionComponent<TrialPriceParagraphProps> = (props) => {
  const pricing = useAppStore((state) => state.pricing);

  return <Paragraph>{PricingSelector.priceForTrialPlan(pricing, props.plan).toString()}</Paragraph>;
};

type ButtonProps = {
  selected: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

const Choice = styled(Button)<ButtonProps>`
  width: 145px;
  height: 56px;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-width: 2px;
  background: ${(props) =>
    appOverride({
      nerva: 'rgba(0, 0, 0, 0.2)',
      default: props.selected ? Color.action.accent : Color.surface.default,
    })};
  border-color: ${(props) =>
    appOverride({
      nerva: 'transparent',
      default: props.selected ? Color.action.accent : Color.action.muted,
    })};
  color: ${Color.content.default};
  &:focus,
  &:hover {
    background: ${(props) =>
      appOverride({
        nerva: 'rgba(0, 0, 0, 0.3)',
        default: props.selected ? Color.action.accent : Color.action.muted,
      })};
    border-color: ${(props) =>
      appOverride({
        nerva: 'transparent',
        default: props.selected ? Color.action.accent : Color.action.muted,
      })};
    color: ${Color.content.default};
  }
`;

const ChoiceContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: ${({ theme }) => theme.spacing._10px};
  padding-right: ${({ theme }) => theme.spacing._10px};
  margin-top: ${({ theme }) => theme.spacing._30px};
`;

const Paragraph = styled(BodyXS)`
  margin: 0px;
`;
